import React, {
  useState, useEffect, useRef, useCallback, Suspense,
} from 'react';
import { isMobile } from '$/utils';
import { getHomeCaseList } from '$/domains/material/materialService';

const CaseListMobile = React.lazy(() => import('./CaseListMobile'));
const CaseListWeb = React.lazy(() => import('./CaseListWeb'));

/** 占位高度，避免懒加载前布局塌陷 */
const PLACEHOLDER_MIN_HEIGHT = 200;

export default function CaseList() {
  const [inView, setInView] = useState(false);
  const [list, setList] = useState<
  Awaited<ReturnType<typeof getHomeCaseList>>['list']
  >([]);
  const wrapperRef = useRef<HTMLDivElement>(null);

  const onIntersect = useCallback<IntersectionObserverCallback>((entries) => {
    const [entry] = entries;
    if (entry?.isIntersecting) setInView(true);
  }, []);

  useEffect(() => {
    const el = wrapperRef.current;
    if (!el) return undefined;
    const observer = new IntersectionObserver(onIntersect, {
      root: null,
      rootMargin: '600px',
      threshold: 0,
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, [onIntersect]);

  useEffect(() => {
    if (!inView) return;
    getHomeCaseList({ category_id: 0, count: 50, page: 1 })
      .then((res) => setList(res.list ?? []))
      .catch(() => setList([]));
  }, [inView]);

  const ListComponent = isMobile() ? CaseListMobile : CaseListWeb;

  return (
    <div ref={wrapperRef} style={!inView ? { minHeight: PLACEHOLDER_MIN_HEIGHT } : undefined}>
      {inView ? (
        <Suspense fallback={<div style={{ minHeight: PLACEHOLDER_MIN_HEIGHT }} />}>
          <ListComponent list={list} />
        </Suspense>
      ) : null}
    </div>
  );
}
